// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__PmF9N","footer":"ChangeClinic_footer__3smcL"};